(() => {
  document.querySelectorAll('[data-cv-postcode]').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const input = form.elements.postcode;
    const result = form.querySelector('[data-delivery-result]');
    form.addEventListener('submit', event => {
      event.preventDefault();
      const postcode = input.value.trim();
      if (!/^\d{4}$/.test(postcode) || Number(postcode) < 200) {
        input.setAttribute('aria-invalid', 'true');
        result.textContent = 'Enter a four-digit Australian postcode.';
        return;
      }
      input.removeAttribute('aria-invalid');
      const day = new Intl.DateTimeFormat('en-CA', {timeZone:'Australia/Sydney',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
      const addDays = count => {
        const date = new Date(day + 'T12:00:00Z');
        while (count) { date.setUTCDate(date.getUTCDate()+1); if (![0,6].includes(date.getUTCDay())) count--; }
        return new Intl.DateTimeFormat('en-AU',{day:'numeric',month:'short',timeZone:'UTC'}).format(date);
      };
      result.textContent = `Example for ${postcode}: ${addDays(3)}–${addDays(5)} · Free standard delivery. Illustrative only; holidays and remote-area eligibility not checked.`;
    });
    input.addEventListener('input', () => { input.removeAttribute('aria-invalid'); result.textContent = 'Sample estimate · No address is saved.'; });
  });
})();
